import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const FALLBACK = {
    eyebrow: "Sobre",
    headline_pre: "Onde a consciência",
    headline_em: "encontra a ciência",
    intro: "",
    cards: [],
    stats: [],
    method_eyebrow: "Nosso método",
    method_title: "",
    method_body: "",
};

export default function Sobre() {
    const [c, setC] = useState(FALLBACK);

    useEffect(() => {
        api.get("/pages/sobre").then((r) => setC({ ...FALLBACK, ...(r.data?.content || {}) })).catch(() => {});
    }, []);

    return (
        <div className="min-h-screen relative grain">
            <Header />
            <main className="max-w-[1100px] mx-auto px-6 md:px-10 pt-14 pb-24">
                <div className="overline text-[#5C5C5C]">{c.eyebrow}</div>
                <h1 className="font-display font-light text-5xl md:text-6xl mt-2 tracking-tight">
                    {c.headline_pre} <span className="font-editorial italic text-holo">{c.headline_em}</span>
                </h1>
                <p className="font-body text-lg text-[#3D3D3D] mt-6 max-w-2xl leading-relaxed">{c.intro}</p>

                <section data-testid="about-mission" className="mt-16 grid md:grid-cols-3 gap-6">
                    {(c.cards || []).map((card, i) => (
                        <article key={i} className="bg-white rounded-3xl p-8 border border-black/5">
                            <div className="overline text-[#5C5C5C]">{card.eyebrow}</div>
                            <h3 className="font-display text-2xl mt-2 tracking-tight">{card.title}</h3>
                            <p className="font-body text-sm text-[#5C5C5C] mt-3 leading-relaxed">{card.body}</p>
                        </article>
                    ))}
                </section>

                <section data-testid="about-numbers" className="mt-16 grid sm:grid-cols-3 gap-6">
                    {(c.stats || []).map((s, i) => (
                        <div key={i} className="rounded-3xl p-8 bg-gradient-to-br from-[#00D4D4]/10 via-white to-[#9370DB]/10 border border-black/5">
                            <div className="font-display font-light text-5xl tracking-tighter">{s.n}</div>
                            <div className="overline text-[#5C5C5C] mt-2">{s.l}</div>
                        </div>
                    ))}
                </section>

                <section className="mt-16 bg-white rounded-3xl p-10 md:p-14 border border-black/5">
                    <div className="overline text-[#5C5C5C]">{c.method_eyebrow}</div>
                    <h2 className="font-display font-light text-3xl md:text-4xl tracking-tight mt-2">{c.method_title}</h2>
                    <p className="font-body text-[#3D3D3D] mt-5 max-w-3xl leading-relaxed">{c.method_body}</p>
                </section>
            </main>
            <Footer />
        </div>
    );
}
